// currently login is implemented as a post request on php


export default class LoginIndex {

    constructor() {




        this.events()
        this.onLoad()
    }


    onLoad() {


    }


    events() {

        // $('#login-form').on('submit', e => this.performLogin(e))


    }


    performLogin(e) {



    }

}
